module.exports = ".card-body[_ngcontent-c4] {\n    padding: 1rem 1rem;\n}"